import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown'

import FrameL from 'component/FrameL';
import { IoMdClose } from 'react-icons/io';


import './style.css';

export default ({ cmsData = {} }) => {
    const { name, description, restrictions, photo, bookingLink = process.env.REACT_APP_DEFAULT_BOOK_NOW, phone, price, id, startDate, endDate } = cmsData;

    const [isDetailsOpen, setDetailsOpen] = useState(false);

    useEffect(() => {
        if (isDetailsOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [isDetailsOpen]);

    return <div>
        <div className="relative cursor-pointer" onClick={() => setDetailsOpen(true)}>
            <FrameL ratio="16:9" Image={photo} ></FrameL>
            <div className="absolute bottom-0 left-0 h-20 w-full bg-accent-green bg-opacity-70 flex flex-col items-center justify-center">
                <h2 className="text-accent text-white uppercase">{name}</h2>
            </div>
        </div>

        <div className={`relative special__modal bg-white p-4 ${isDetailsOpen ? 'active' : ''}`}>
            <div className="relative">
                <FrameL ratio="13:9" ratioAboveMd="16:9" ratioAboveLg="21:9" Image={photo}></FrameL>
                <button className="absolute m-4 top-0 right-0 bg-accent-green text-white">
                    <IoMdClose
                        className="icon text-gray-200"
                        onClick={() => {
                            setDetailsOpen(false);
                        }}
                    />
                </button>
            </div>

            <div className="relative py-4 items-start grid lg:grid-flow-col grid-cols-1 lg:grid-cols-10 gap-4 lg:gap-8">
                <div className="lg:col-span-2 w-full">
                    <h3 className="text-center" style={{ marginTop: 'var(--s2)' }}>{name}</h3>
                </div>
                <ReactMarkdown className="lg:col-span-6 leading-loose text-lg">
                    {description}
                </ReactMarkdown>
                <div className="lg:col-span-2 w-full flex justify-center">
                    <a
                        href={bookingLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Booking Link"
                        className="btn-lg bg-accent-green text-white">Book Now</a>
                </div>
                <button className="absolute m-4 bottom-0 right-0 bg-accent-green text-white">
                    <IoMdClose
                        className="icon text-gray-200"
                        onClick={() => {
                            setDetailsOpen(false);
                        }}
                    />
                </button>
            </div>
        </div>
    </div>;
}